import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { ReactComponent as Calculator } from '../../assets/icons/calculator-icon.svg';
import { ReactComponent as Plus } from '../../assets/icons/plus.svg';
import { PortalType } from '../../config/enum';
import { usePortal } from '../../contexts/PortalContext/PortalContext';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { setPageTitle } from '../../redux/slices/PageTitleSlice';
import MyButton from '../../shared-components/button/Button';
import TabToggle from '../../shared-components/tab-toggle/TabToggle';
import { permissionCheck } from '../../shared-functions/JWTDocodeFunction';

import Custom from './components/Custom';
import Global from './components/Global';
import Partner from './components/Partner';

/**
 * Component for displaying tariffs
 * @returns {React.JSX.Element} Tariff component
 */
function Tariff(): any {
  const { t } = useTranslation('tariff');
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [selectedTab, setSelectedTab] = useState<string>('Global');
  const { tariffCounts } = useAppSelector((state) => state.tariff);
  const { portalType, activePortal } = usePortal();
  const isPartnerPortal = portalType === PortalType.PARTNER || activePortal === PortalType.PARTNER;

  useEffect(() => {
    dispatch(
      setPageTitle({
        title: t('chargingTariffs'),
      }),
    );
  }, [dispatch, t]);

  return (
    <div className="tariff-page-wrapper">
      <div className="tariff-header">
        <TabToggle
          tabs={[
            { label: t('global'), value: 'Global', count: tariffCounts?.global || 0 },
            { label: t('custom'), value: 'Custom', count: tariffCounts?.custom || 0 },
            ...(!isPartnerPortal
              ? [{ label: t('partner'), value: 'Partner', count: tariffCounts?.partnerCreate || 0 }]
              : []),
          ]}
          value={selectedTab}
          defaultTab="Global"
          isLabelValue
          onChange={(tab) => setSelectedTab(tab)}
        />
        <div className="add-tariff-button">
          <MyButton
            label={t('tariffCalculator')}
            buttonType="primary-outline"
            onClickFunc={() => navigate('/ev-admin/tariffs/calculator')}
            svgIcon={<Calculator />}
            disableButton={
              !permissionCheck('partnerTariffCalculation') &&
              !permissionCheck('cpoTariffCalculation')
            }
          />
          <MyButton
            label={t('addTariff')}
            buttonType="submit"
            onClickFunc={() => navigate('/ev-admin/tariffs/add-tariff')}
            svgIcon={<Plus />}
            disableButton={!permissionCheck('partnerTariffAdd') && !permissionCheck('cpoTariffAdd')}
          />
        </div>
      </div>
      <div className="tariff-table-wrapper">
        {selectedTab === 'Global' && <Global />}
        {selectedTab === 'Custom' && <Custom />}
        {!isPartnerPortal && selectedTab === 'Partner' && <Partner />}
      </div>
    </div>
  );
}

export default Tariff;
